import React from "react";
import { Card, CardContent, Typography, Button, Box } from "@mui/material";
import { Bed, Bathtub, DirectionsCar, AspectRatio } from "@mui/icons-material";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import "./HomeCard.css"; // Your custom styles

const HomeCard = ({ home }) => {
  if (!home) return null;

  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className="home-card-container"
    >
      <Card className="home-card" elevation={4}>
        <img src={home.thumbnail} alt={home.name} className="home-image" />

        <CardContent className="home-card-content-main-container">
          <Typography variant="h5" className="home-name">
            {home.name}
          </Typography>

          <Box className="home-info">
            <Typography className="home-detail">
              <Bed sx={{ mr: 0.5 }} /> {home.bedrooms} Bedrooms
            </Typography>
            <Typography className="home-detail">
              <Bathtub sx={{ mr: 0.5 }} /> {home.bathrooms} Bathrooms
            </Typography>
            <Typography className="home-detail">
              <DirectionsCar sx={{ mr: 0.5 }} /> {home.parking} Parking
            </Typography>
            <Typography className="home-detail">
              <AspectRatio sx={{ mr: 0.5 }} /> {home.totalArea} square
            </Typography>
          </Box>

          <Button
            variant="contained"
            color="primary"
            fullWidth
            className="view-more-btn"
            component={Link}
            to={`/project/${home._id}`}
          >
            View More
          </Button>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default HomeCard;
